module.exports = __webpack_public_path__ + "img/window.801a4d7f.svg";